/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentExchangeHistoryEntryResponse
 */
export interface AppointmentExchangeHistoryEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    exchangeId: string;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    acceptedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    givenAwayByUserCode: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    givenStartTimeUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    givenIsAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    givenPurposeKey: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    exchangedWithUserCode: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    receivedStartTimeUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    receivedIsAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeHistoryEntryResponse
     */
    receivedPurposeKey: string;
}

/**
 * Check if a given object implements the AppointmentExchangeHistoryEntryResponse interface.
 */
export function instanceOfAppointmentExchangeHistoryEntryResponse(value: object): value is AppointmentExchangeHistoryEntryResponse {
    if (!('exchangeId' in value) || value['exchangeId'] === undefined) return false;
    if (!('acceptedAtUtc' in value) || value['acceptedAtUtc'] === undefined) return false;
    if (!('givenAwayByUserCode' in value) || value['givenAwayByUserCode'] === undefined) return false;
    if (!('givenStartTimeUtc' in value) || value['givenStartTimeUtc'] === undefined) return false;
    if (!('givenIsAllDay' in value) || value['givenIsAllDay'] === undefined) return false;
    if (!('givenPurposeKey' in value) || value['givenPurposeKey'] === undefined) return false;
    if (!('exchangedWithUserCode' in value) || value['exchangedWithUserCode'] === undefined) return false;
    if (!('receivedStartTimeUtc' in value) || value['receivedStartTimeUtc'] === undefined) return false;
    if (!('receivedIsAllDay' in value) || value['receivedIsAllDay'] === undefined) return false;
    if (!('receivedPurposeKey' in value) || value['receivedPurposeKey'] === undefined) return false;
    return true;
}

export function AppointmentExchangeHistoryEntryResponseFromJSON(json: any): AppointmentExchangeHistoryEntryResponse {
    return AppointmentExchangeHistoryEntryResponseFromJSONTyped(json, false);
}

export function AppointmentExchangeHistoryEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentExchangeHistoryEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'exchangeId': json['exchangeId'],
        'acceptedAtUtc': (new Date(json['acceptedAtUtc'])),
        'givenAwayByUserCode': json['givenAwayByUserCode'],
        'givenStartTimeUtc': (new Date(json['givenStartTimeUtc'])),
        'givenIsAllDay': json['givenIsAllDay'],
        'givenPurposeKey': json['givenPurposeKey'],
        'exchangedWithUserCode': json['exchangedWithUserCode'],
        'receivedStartTimeUtc': (new Date(json['receivedStartTimeUtc'])),
        'receivedIsAllDay': json['receivedIsAllDay'],
        'receivedPurposeKey': json['receivedPurposeKey'],
    };
}

export function AppointmentExchangeHistoryEntryResponseToJSON(json: any): AppointmentExchangeHistoryEntryResponse {
    return AppointmentExchangeHistoryEntryResponseToJSONTyped(json, false);
}

export function AppointmentExchangeHistoryEntryResponseToJSONTyped(value?: AppointmentExchangeHistoryEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exchangeId': value['exchangeId'],
        'acceptedAtUtc': value['acceptedAtUtc'].toISOString(),
        'givenAwayByUserCode': value['givenAwayByUserCode'],
        'givenStartTimeUtc': value['givenStartTimeUtc'].toISOString(),
        'givenIsAllDay': value['givenIsAllDay'],
        'givenPurposeKey': value['givenPurposeKey'],
        'exchangedWithUserCode': value['exchangedWithUserCode'],
        'receivedStartTimeUtc': value['receivedStartTimeUtc'].toISOString(),
        'receivedIsAllDay': value['receivedIsAllDay'],
        'receivedPurposeKey': value['receivedPurposeKey'],
    };
}

